import React from 'react';
import './Gis.css';
import Menu from '../../Menu/Menu';
import b8 from '../../../img/B-2.jpg';
import b9 from '../../../img/B-2.png';
import b10 from '../../../img/gis2.jpg'



const Gis = () => {
    return (
        <div className='mb-5'>
            
            <div className='about2'>
                <div className='bg'>
                    <Menu></Menu>
                    <h1 className='text-white display-5 fw-bold doris pt-lg-5 pb-5 mx-auto top'>Geographical Information System (GIS)</h1>
                </div>
            </div>

            <div id="gis">
                <h2 className='heading pt-5 px-3'>Geographical Information System (GIS)</h2>
                <hr className='w-75 mx-auto'></hr>
                <h5 className='px-5 mx-lg-3'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 pt-3 mb-3'>
                            A geographic information system
                            (GIS) is a system that creates, manages, analyzes, and maps all types of data. GIS
                            connects data to a map, integrating location data (where things are) with all types
                            of descriptive information (what things are like there). This provides a foundation for
                            mapping and analysis that is used in science and almost every industry. GIS helps
                            users understand patterns, relationships, and geographic context. Processes of GIS is
                            different map & digital data conversion, Georeferencing of map, satellite image
                            and aerial photograph, digitizing map and finally map preparation.

                            <img src={b8} alt="" width="100%" className='me-2 mt-5 pt-4'/>
                        </div>
                        
                        <div className='col-lg-6 col-md-6 col-sm-12 px-lg-5'>
                            <div className='mt-3'>
                                    <img src={b10} alt="" width="90%" className='ms-4'/>
                                    <img src={b9} alt="" width="100%" className='me-2'/>
                                </div>
                        </div>
                    </div>
                </h5>
            </div>            
        </div>
    );
};

export default Gis;